import React from "react";

const PageHeader = (props) => {
  return <div className="page-header">{props.children}</div>;
};

export default PageHeader;
